import { LoadingOutlined } from "@ant-design/icons";
import classes from "./ShareModalContent.module.css";

/**
 * A dialog footer button styled by this dialog alone. antd's Button is not used
 * here: from antd 5.2x its hover and press styles out-rank ours and turn the
 * button white. `variant` is "primary" or "danger"; `isBusy` shows a spinner.
 */
export const FooterButton = ({ variant = "primary", isBusy = false, disabled = false, children, ...buttonProps }) => (
  <button
    type="button"
    {...buttonProps}
    className={`${classes.button} ${classes[variant]}`}
    disabled={disabled || isBusy}
    aria-busy={isBusy}
  >
    {isBusy && <LoadingOutlined className={classes.spinner} aria-hidden="true" />}
    {children}
  </button>
);
